import { motion, AnimatePresence } from "framer-motion";
import { Box, Text, Grid, useToast, Heading } from '@chakra-ui/react'
import { useEffect, useState } from "react";
import Button from "./Button";
import Square from "./Square";
import './TicTacToe.css'
import axios from 'axios';
import io from 'socket.io-client';


// var socket = io('http://localhost:4000', {transports: ['polling']});


export const TicTacToeOnline = () => {
    const [squares, setSquares] = useState(Array(9).fill(""));
    const [turn, setTurn] = useState("x");
    const [winner, setWinner] = useState(null);
    const [data, setData] = useState('')
    const [roomName, setRoomName] = useState('100');
    const [message, setMessage] = useState();
    const [messages, setMessages] = useState([]);
    const [socket, setSocket] = useState(null);


    const checkEndTheGame = () => {
        for (let square of squares) {
            if (!square) return false;
        }
        return true;
    }

    const checkWinner = () => {
        const combos = [
            [0, 1, 2],
            [3, 4, 5],
            [6, 7, 8],
            [0, 3, 6],
            [1, 4, 7],
            [2, 5, 8],
            [0, 4, 8],
            [2, 4, 6],
        ];

        for (let combo of combos) {
            const [a, b, c] = combo;
            if (
                squares[a] &&
                squares[a] === squares[b] &&
                squares[a] === squares[c]
            ) {
                return squares[a];
            }
        }
        return null;
    };

    const updateSquares = (ind) => {


        if (squares[ind] || winner) {
            return;
        }

        if(message!=ind){
            handleSendMessage(ind)
        }


        const s = squares;
        s[ind] = turn;
        setSquares(s);
        setTurn(turn === "x" ? "o" : "x");
        console.log(turn === "x")
        const W = checkWinner();
        if (W) {
            setWinner(W);
        } else if (checkEndTheGame()) {
            setWinner("x | o");
        }
    };

    const resetGame = () => {
        setSquares(Array(9).fill(""));
        setTurn("x");
        setWinner(null);
    };



    const handleJoinRoom = () => {
        if (roomName) {
            const newSocket = io('http://localhost:4000'); // Replace with your server URL
            newSocket.emit('join room', roomName);
            newSocket.on('room joined', (joinedRoomName) => {
                console.log(`Joined room: ${joinedRoomName}`);
            });
            newSocket.on('chat message', (newMessage) => {
                updateSquares(newMessage)
                setMessage(newMessage)
            });
            setSocket(newSocket);
        }
    };


    const handleSendMessage = (data) => {
        if (data && socket) {
            socket.emit('chat message', data, roomName);
        }
    };

    useEffect(() => {
        handleJoinRoom()
    }, [])

    return (
        <Box bg={'#222'} minHeight={'100vh'} border={'1px solid #222'}>
            <Box display={'flex'} justifyContent={'space-between'}>
                <Heading color={'transparent'} fontWeight={'medium'} fontSize={'27px'} m={'15px 0 0 1cm'} style={{ backgroundImage: 'linear-gradient(30deg, rgb(0, 170, 255), rgb(1, 279, 16))', WebkitBackgroundClip: 'text', backgroundClip: 'text', }}>||| TIC TAC TOE</Heading>
                <Box>
                    <input onChange={(e) => setData(e.target.value)} value={data} style={{ padding: '10px' }} type="text" placeholder="Enter" />
                    <button onClick={handleSendMessage} style={{ padding: '10px 20px', color: 'white', border: '1px solid white' }}>add</button>
                </Box>
            </Box>
            <div className="tic-tac-toe">
                <div className={`turn ${turn === "x" ? "left" : "right"}`}>
                    <Square clsName="x" />
                    <Square clsName="o" />
                </div>

                <div className="game">
                    {Array.from("012345678").map((ind) => (
                        <Square key={ind} ind={ind} updateSquares={updateSquares} clsName={squares[ind]} />
                    ))}
                </div>

                <Button resetGame={resetGame} />

                <AnimatePresence>
                    {winner && (
                        <motion.div key={"parent-box"} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="winner"  >
                            <motion.div key={"child-box"} initial={{ scale: 0 }} animate={{ scale: 1 }} exit={{ scale: 0, opacity: 0 }} className="text"  >
                                <motion.h2 initial={{ scale: 0, y: 100 }} animate={{ scale: 1, y: 0, transition: { y: { delay: 0.7 }, duration: 0.7, }, }} >
                                    {winner === "x | o" ? "No Winner (⊙ˍ⊙)" : "Win !! :)"}
                                </motion.h2>
                                <motion.div initial={{ scale: 0 }} animate={{ scale: 1, transition: { delay: 1.3, duration: 0.2, }, }} className="win" >
                                    {winner === "x | o" ? (
                                        <>
                                            <Square clsName="x" />
                                            <Square clsName="o" />
                                        </>
                                    ) : (
                                        <>
                                            <Square clsName={winner} />
                                        </>
                                    )}
                                </motion.div>
                                <motion.div initial={{ scale: 0 }} animate={{ scale: 1, transition: { delay: 1.5, duration: 0.3 }, }}>
                                    <Button resetGame={resetGame} />
                                </motion.div>
                            </motion.div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>
        </Box>
    );
}